import { render, staticRenderFns } from "./Audittransactions.vue?vue&type=template&id=36a24352&"
import script from "./Audittransactions.vue?vue&type=script&lang=js&"
export * from "./Audittransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports